module.exports = __webpack_public_path__ + "static/assets/7308b19c064285396e8ec813a766e21f.png";